<template>
  <section v-if="fixture.id">
    <div class="col-sm-12 table-responsive tbl-display-fixture-inplay">
      <table class="table table-bordered">
        <thead>
        <tr>
          <td class="text-center" width="15%"><strong>Time</strong></td>
          <td class="text-center">Match Status</td>
          <td class="text-center" width="15%"><strong>Home</strong></td>
          <td class="text-center" width="5%"><strong>Score</strong></td>
          <td class="text-center" width="15%"><strong>Away</strong></td>
          <td class="text-center" width="5%"><strong>FT</strong></td>
          <td class="text-center" width="5%"><strong>HT</strong></td>
          <td class="text-center">Status</td>
          <td class="text-center" width="15%">
            <span class=" btn  btn-xs text-white" :class="timeSync<4?'btn-warning':'btn-info'" @click="reload()"> ( {{ timeSync}} ) Reload</span>
          </td>
          <td class="text-center"><a :href="switchUrl" class="text-info">Go to Pre Match</a></td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-center" width="15%">
            <small>
              {{ getMoment(fixture.local_starting_at, 'MMM') }} {{ getMoment(fixture.local_starting_at, 'YYYY') }}<br/>
              {{ getMoment(fixture.local_starting_at, 'DD') }} {{ getMoment(fixture.local_starting_at, 'dddd HH:mm') }}
            </small>
          </td>
          <td class="text-center">
            <span class="text-info" v-html="getMatchStatus(fixture)"></span>
          </td>
          <td class="text-center" width="15%">
            <span class="pull-left" v-html="getTeamIcon(getProperty(fixture,'meta.localteam.logo_path'))"></span>{{ fixture.meta.localteam.name }}
          </td>
          <td class="text-center" width="5%">{{ scoreDisplayScore(fixture) }}</td>
          <td class="text-center" width="15%">{{ fixture.meta.visitorteam.name }}<span class="pull-right" v-html="getTeamIcon(getProperty(fixture,'meta.visitorteam.logo_path'))"></span>
          </td>
          <td class="text-center" width="5%">{{ scoreDisplay(fixture) ? fixture.ft_score : '?-?' }}</td>
          <td class="text-center" width="5%">{{ scoreDisplay(fixture) ? fixture.ht_score : '?-?' }}</td>
          <td class="text-center">{{ fixture.status }}<br/>
            <div class="switch pull-left">
              <div class="onoffswitch">
                <input type="checkbox" name="collapsemenu" v-model="fixture.active" class="onoffswitch-checkbox" :id="'collapsemenu-'+fixture.id" @change.prevent="setActive($event)">
                <label class="onoffswitch-label" :for="'collapsemenu-'+fixture.id">
                  <span class="onoffswitch-inner"></span>
                  <span class="onoffswitch-switch"></span>
                </label>
              </div>
            </div>
          </td>
          <td class="text-center" width="15%">{{ fixture.updated_at }}</td>
          <td class="text-center">
            <span class="btn-sync-fixture btn btn-sm btn-info" @click="syncFixtureById(fixture.id)"><i class="fa fa-refresh"></i> อัพเดตข้อมูล</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-5 col-sm-offset-7 text-right">
      <a href="javascript:void(0)" v-on:click='showVdo = !showVdo'><i class="fa fa-eye"></i> {{ showVdo ? 'Hide' : 'Show Vdo' }}</a>
      <div class="txt-vdo">
        <select class="form-control" v-model="fixture.vdo_url" @change="updateVdo()">
          <option value="">เลือก VDO {{ vdo_url }}</option>
          <option :value="configUrl.url" v-for="(configUrl,index) in getSteamUrl()">{{ configUrl.name }}</option>
        </select>
      </div>
      <br/>
    </div>
    <div class="col-sm-12 text-center" v-show="showVdo">
      <div id='sldp_player_wrapper'></div>
    </div>
    <div class="col-sm-12" v-if="fixture.id">

      <a href="javascript:void(0)" v-on:click='showStats = !showStats'><i class="fa fa-signal"></i> {{ showStats ? 'Hide' : 'Show Stats' }}</a>

      <table class="table " v-show="showStats">
        <thead>
        <tr>
          <td width="40%"></td>
          <td></td>
          <td width="40%"></td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-right">
            <span v-html="getTeamIcon(getProperty(fixture,'meta.localteam.logo_path'))"></span>{{ fixture.meta.localteam.name }}
          </td>
          <td></td>
          <td class="text-left">{{ fixture.meta.visitorteam.name }}<span v-html="getTeamIcon(getProperty(fixture,'meta.visitorteam.logo_path'))"></span>
          </td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'attacks[0]', '-') }}</td>
          <td class="text-center" width="170px">Attacks</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'attacks[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corners[0]', '-') }}
            <br/>
            <input v-if="statsActive['corners']" v-model="statsHome" type="number" min="0" class="input-sm form-control input-stats pull-right"/>
          </td>
          <td class="text-center" width="170px">Corners
            <span class="text-info"><i class="fa fa-pencil" @click="editStats('corners')"></i></span>
            <br/>
            <button v-if="statsActive['corners']" class="btn btn-xs btn-primary" @click="saveDataStats()">Save</button>
            <button v-if="statsActive['corners']" class="btn btn-xs btn-danger" @click="editStats('corners',true)">Cancel</button>
          </td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corners[1]', '-') }}
            <br/>
            <input v-if="statsActive['corners']" v-model="statsAway" type="number" min="0" class="input-sm form-control input-stats"/>
          </td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corner_ft[0]', '-') }}
            <br/>
            <input v-if="statsActive['corner_ft']" v-model="statsHome" type="number" min="0" class="input-sm form-control input-stats pull-right"/>
          </td>
          <td class="text-center" width="170px">Corner FT
            <span class="text-info"><i class="fa fa-pencil" @click="editStats('corner_ft')"></i></span>
            <br/>
            <button v-if="statsActive['corner_ft']" class="btn btn-xs btn-primary" @click="saveDataStats()">Save</button>
            <button v-if="statsActive['corner_ft']" class="btn btn-xs btn-danger" @click="editStats('corner_ft',true)">Cancel</button>
          </td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corner_ft[1]', '-') }}
            <br/>
            <input v-if="statsActive['corner_ft']" v-model="statsAway" type="number" min="0" class="input-sm form-control input-stats"/>
          </td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corner_ht[0]', '-') }}
            <br/>
            <input v-if="statsActive['corner_ht']" v-model="statsHome" type="number" min="0" class="input-sm form-control input-stats pull-right"/>
          </td>
          <td class="text-center" width="170px">Corner HT
            <span class="text-info"><i class="fa fa-pencil" @click="editStats('corner_ht')"></i></span>
            <br/>
            <button v-if="statsActive['corner_ht']" class="btn btn-xs btn-primary" @click="saveDataStats()">Save</button>
            <button v-if="statsActive['corner_ht']" class="btn btn-xs btn-danger" @click="editStats('corner_ht',true)">Cancel</button>
          </td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corner_ht[1]', '-') }}
            <br/>
            <input v-if="statsActive['corner_ht']" v-model="statsAway" type="number" min="0" class="input-sm form-control input-stats"/>
          </td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'dangerous_attacks[0]', '-') }}</td>
          <td class="text-center" width="170px">Dangerous Attacks</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'dangerous_attacks[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'goals[0]', '-') }}</td>
          <td class="text-center" width="170px"><i class="fa fa-soccer-ball-o"></i> Goals</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'goals[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'off_target[0]', '-') }}</td>
          <td class="text-center" width="170px">Off Target</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'off_target[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'on_target[0]', '-') }}</td>
          <td class="text-center" width="170px">On Target</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'on_target[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'penalties[0]', '-') }}</td>
          <td class="text-center" width="170px">Penalties</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'penalties[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'possession_percent[0]', '-') }}</td>
          <td class="text-center" width="170px">Possession Percent</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'possession_percent[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'redcards[0]', '-') }}</td>
          <td class="text-center" width="170px"><i class="football-card red-card"></i> Red cards</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'redcards[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'yellowcards[0]', '-') }}</td>
          <td class="text-center" width="170px"><i class="football-card yellow-card"></i> Yellow cards</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'yellowcards[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'substitutions[0]', '-') }}</td>
          <td class="text-center" width="170px">Substitutions</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'substitutions[1]', '-') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <section v-for="(type,i) in betType">
      <div class="col-sm-12 container-market">
        <div class="col-sm-12 gl-market-group-button">
          <span class="gl-market-group-button-text">{{ type.name }}</span>
          <span class="btn-add-show" @click="setCreateToggle(type.slug)"><i class="fa fa-plus text-info" v-show="!getCreateToggle(type.slug, 'editing')"></i> {{ getCreateToggle(type.slug, 'editing') ? 'ปิด' : 'เพิ่ม' }}</span>
        </div>
        <section class="group-key" v-for="(recordKey, i) in getOdds(type.slug,'odds')" @dblclick="setBreakSync(type.slug,true,false)">
          <div class="group-container" v-for="(records, i) in recordKey">
            <div class="gl-participant gl-participant-general" v-for="(record, i) in setSortHDA(records)" :class="getChunk(type,record)">
              <span class="gl-participant-name"><span class="label label-danger label-xs" v-if="record.not_sync===1 && fixture.ref_status!='FT' "><i class="fa fa-refresh"></i></span> {{ record.header }}</span>
              <span class="gl-participant-handicap" v-show="isHandicap(record)">{{ record.handicap }}</span>
              <span class="gl-participant-total" v-show="isTotal(record)">{{ record.total }}</span>
              <span class="gl-participant-odds" v-show="!getBreakSync(type.slug)">{{ record.value }} <span class="inplay_score" v-show="record.inplay_score">@{{ getInPlayScore(record) }}<span class="text-danger" v-show="record.ref1">, {{ record.ref1 }}'</span></span></span>
              <span class="gl-participant-winning" v-show="record.winning>0 && !getBreakSync(type.slug)"></span>
              <span class="gl-participant-payment-rate" v-show="record.payment_rate>0 && !getBreakSync(type.slug)"><span class="label" :class="paymentClass(record)">{{ toFloat(record.payment_rate) }}</span></span>
              <span class="gl-participant-value-edit" v-show="getBreakSync(type.slug)"><input type="text" v-model="record.value"></span>
              <span class="gl-participant-active" v-show="getBreakSync(type.slug)"><label class="k-checks"><input type="checkbox" v-model="record.active"> Active</label></span>
              <span class="gl-participant-not-sync" v-show="getBreakSync(type.slug)"><label class="k-checks"><input type="checkbox" v-model="record.not_sync"> Not Sync</label></span>
              <span class="gl-participant-logs" v-html="getLastLogs(record)" v-show="!getBreakSync(type.slug)"></span>
            </div>
          </div>
        </section>
        <div class="clearfix"></div>
        <div class="gl-market-group-action" v-show="getBreakSync(type.slug)">
          <div class="form-group">
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10">
              <label class="radio-inline k-checks">
                <input type="checkbox" @change.prevent="setSelectActiveAll(type.slug,$event)"> เปิดใช้งานทั้งหมด </label>
              <label class="radio-inline k-checks">
                <input type="checkbox" @change.prevent="setSelectNotSyncAll(type.slug,$event)"> ปิดการอัพเดตอัตโนมัติทั้งหมด </label>
            </div>
          </div>
          <button class="btn btn-sm btn-primary" @click="saveDataOdds(type.slug)">Save</button>
          <button class="btn btn-sm btn-danger" @click="setBreakSync(type.slug)">Cancel</button>
        </div>
        <div class="clearfix"></div>
        <section class="create-odds" v-show="getCreateToggle(type.slug)">
          <div class="create-odds-title"><span class="title-create-odd">สร้าง ราคาเพิ่มเติม</span></div>
          <div class="group-container" v-for="(records, i) in slugCreate[type.slug].odds">
            <div class="gl-participant gl-participant-general " v-for="(record, i) in records" :class="getChunk(type,record,false)">
              <span class="gl-participant-name">{{ record.showText }}</span>
              <span class="gl-participant-handicap-edit" v-show="record.type==='handicap'"><input type="number" v-model="record.handicap" placeholder="Handicap"></span>
              <span class="gl-participant-total-edit" v-show="record.type==='total'"><input type="number" v-model="record.total" placeholder="Total"></span>
              <span class="gl-participant-value-edit"><input type="number" v-model="record.value" placeholder="Rate"></span>
              <span class="gl-participant-active"><label class="k-checks"><input type="checkbox" v-model="record.active"> Active</label></span>
              <span class="gl-participant-not-sync"><label class="k-checks"><input type="checkbox" v-model="record.not_sync"> Not Sync</label></span>
            </div>
          </div>
          <div class="gl-market-group-action">
            <button class="btn btn-sm btn-primary" @click="createDataOdds(type.slug)">Save</button>
            <button class="btn btn-sm btn-danger" @click="setCreateToggle(type.slug)">Cancel</button>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>
<script>
  import {
    getMoment,
    scoreDisplayScore,
    scoreDisplay,
    paymentClass,
    getLogs,
    setSortHDA,
    getMatchStatus,
    getTeamIcon
  } from './helpers'

  export default {
    name: 'sport-soccer-in-play',
    props: {
      fixtureId: {
        required: true,
      },
      switchUrl: {
        required: true,
      },
      currentSite: {
        required: true
      }
    },
    data() {
      return {
        baseConfigVdo: [
          {url: 'wss://dosod.tv/live/bein_1', name: 'bein_1', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/bein_2', name: 'bein_2', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/bein_3', name: 'bein_3', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/bein_4', name: 'bein_4', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/bein_5', name: 'bein_5', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/Truesport_2', name: 'Truesport_2', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/Truesport_5', name: 'Truesport_5', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/Truesport_6', name: 'Truesport_6', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/Truesport_7', name: 'Truesport_7', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_1', name: 'SkyNetSport_1', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_2', name: 'SkyNetSport_2', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_3', name: 'SkyNetSport_3', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_4', name: 'SkyNetSport_4', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_5', name: 'SkyNetSport_5', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_6', name: 'SkyNetSport_6', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/FoxSport_1', name: 'FoxSport_1', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/FoxSport_2', name: 'FoxSport_2', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/FoxSport_3', name: 'FoxSport_3', site: 'truthbet'},
          {url: 'wss://dosod.tv/live/SkyNetSport_HD', name: 'SKYNETHD', site: 'truthbet'},
          {url: 'wss://tvrealtime.com/live/PPTV', name: 'PPTV', site: 'truthbet'},

          {url: 'wss://tvrealtime.com/live/BEIN1', name: 'BEIN1', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/BEIN2', name: 'BEIN2', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/BEIN3', name: 'BEIN3', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/BEIN4', name: 'BEIN4', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/BEIN5', name: 'BEIN5', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/HD1', name: 'HD1', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/HD2', name: 'HD2', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/HD3', name: 'HD3', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/HD4', name: 'HD4', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/FOXSPORT1', name: 'FoxSport_1', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/FOXSPORT2', name: 'FoxSport_2', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/FOXSPORT3', name: 'FoxSport_3', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET1', name: 'SkyNetSport_1', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET2', name: 'SkyNetSport_2', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET3', name: 'SkyNetSport_3', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET4', name: 'SkyNetSport_4', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET5', name: 'SkyNetSport_5', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNET6', name: 'SkyNetSport_6', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/SKYNETHD', name: 'SKYNETHD', site: 'poipet'},
          {url: 'wss://tvrealtime.com/live/PPTV', name: 'PPTV', site: 'poipet'},

        ],
        sldpPlayer: {},
        editVdo: false,
        vdo_url:
          null,
        statsHome:
          null,
        statsAway:
          null,
        statsActive:
          {}
        ,
        slugCreateTemp: {}
        ,
        slugCreate: {
          'in_play:fulltime_result':
            {
              'odds':
                [
                  [
                    {
                      header: 'Home',
                      showText: 'Home',
                      label: 'Home',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Draw',
                      showText: 'Draw',
                      label: 'Draw',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Away',
                      showText: 'Away',
                      label: 'Away',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
          'in_play:asian_handicap':
            {
              'odds':
                [
                  [
                    {
                      header: 'Home',
                      showText: 'Home',
                      label: 'Home',
                      value: null,
                      total: null,
                      handicap: null,
                      active: 1,
                      not_sync: 0,
                      type: 'handicap',
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Away',
                      showText: 'Away',
                      label: 'Away',
                      value: null,
                      total: null,
                      handicap: null,
                      active: 1,
                      not_sync: 0,
                      type: 'handicap',
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
          'in_play:goal_line':
            {
              'odds':
                [
                  [
                    {
                      header: 'Over',
                      showText: 'Over',
                      label: 'Over',
                      value: null,
                      total: null,
                      active: 1,
                      not_sync: 0,
                      type: 'total',
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Under',
                      showText: 'Under',
                      label: 'Under',
                      value: null,
                      total: null,
                      active: 1,
                      not_sync: 0,
                      type: 'total',
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
//          'in_play:asian_corners':{},
          'in_play:1st_half_asian_handicap':
            {
              'odds':
                [
                  [
                    {
                      header: 'Home',
                      showText: 'Home',
                      label: 'Home',
                      value: null,
                      total: null,
                      handicap: null,
                      active: 1,
                      not_sync: 0,
                      type: 'handicap',
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Away',
                      showText: 'Away',
                      label: 'Away',
                      value: null,
                      total: null,
                      handicap: null,
                      active: 1,
                      not_sync: 0,
                      type: 'handicap',
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
          'in_play:1st_half_goal_line':
            {
              'odds':
                [
                  [
                    {
                      header: 'Over',
                      showText: 'Over',
                      label: 'Over',
                      value: null,
                      total: null,
                      active: 1,
                      not_sync: 0,
                      type: 'total',
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Under',
                      showText: 'Under',
                      label: 'Under',
                      value: null,
                      total: null,
                      active: 1,
                      not_sync: 0,
                      type: 'total',
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
//          'in_play:1st_half_asian_corners':{},
          'in_play:half_time_result':
            {
              'odds':
                [
                  [
                    {
                      header: 'Home',
                      showText: 'Home',
                      label: 'Home',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Draw',
                      showText: 'Draw',
                      label: 'Draw',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    },
                    {
                      header: 'Away',
                      showText: 'Away',
                      label: 'Away',
                      value: null,
                      active: 1,
                      not_sync: 0,
                      type: null,
                      is_option: false,
                      option: []
                    }
                  ]
                ],
              editing:
                false
            }
          ,
//          'in_play:money_line':{},
//          'in_play:spread':{},
//          'in_play:total_points':{},
//          'in_play:draw_no_bet':{},
        }
        ,
        slug: {
          'in_play:fulltime_result':
            {}
          ,
          'in_play:asian_handicap':
            {}
          ,
          'in_play:goal_line':
            {}
          ,
          'in_play:asian_corners':
            {}
          ,
          'in_play:1st_half_asian_handicap':
            {}
          ,
          'in_play:1st_half_goal_line':
            {}
          ,
          'in_play:1st_half_asian_corners':
            {}
          ,
          'in_play:half_time_result':
            {}
          ,
          'in_play:money_line':
            {}
          ,
          'in_play:spread':
            {}
          ,
          'in_play:total_points':
            {}
          ,
          'in_play:draw_no_bet':
            {}
          ,
        }
        ,
        fixtureRefId: null,
        type:
          'in_play',
        fixture: {},
        slugFlashData: {},
        betType: {},
        breakSync: {},
        timeSync: 5,
        baseTimeSync: 5,
        showStats: false,
        showVdo: false
      }
    },
    mounted() {
      this.getDataOdds()
      this.getDataInterVal()
    },
    methods: {
      getMoment(value, format = 'HH:mm', local = 'th') {
        return getMoment(value, format, local)
      },
      getDataInterVal() {
        setInterval(function () {
          this.timeSync--
          if (this.timeSync === 0) {
            this.getDataOdds()
            this.timeSync = _.cloneDeep(this.baseTimeSync)
          }
        }.bind(this), 1000)
      },
      reload() {
        this.getDataOdds()
        this.timeSync = _.cloneDeep(this.baseTimeSync)
        this.renderStreaming()

      },
      getDataOdds() {
        const requestUrl = `spt/soccer/odds/in_play_odds/${this.fixtureId}`
        axios.get(requestUrl)
          .then(response => {
            if (response.data) {
              this.betType = _.cloneDeep(response.data.betType)
              this.fixture = _.cloneDeep(response.data.fixture)
              this.fixtureRefId = this.fixture.ref_id
              const preOdds = response.data.preOdds
              for (let record of this.betType) {
                if (!_.get(preOdds, record.slug)) {
                  continue
                }
                Object.assign(preOdds[record.slug], {editing: false})
                if (!this.getBreakSync(record.slug)) {
                  this.slug[record.slug] = preOdds[record.slug]
                } else {
                  this.slugFlashData[record.slug] = preOdds[record.slug]

                }
              }
            }
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'ไม่สามารถโหลดข้อมูลได้',
              duration: 2000
            })
          })

      },
      syncFixtureById() {
        const requestUrl = `spt/soccer/${this.fixtureId}/sync`
        axios.post(requestUrl)
          .then(response => {
            this.timeSync = 5

            this.$message.success({
              showClose: true,
              message: 'อัพเดตข้อมูลการแข่งขันเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'ไม่สามารถโหลดข้อมูลได้',
              duration: 2000
            })
          })
      },
      saveDataOdds(slug) {
        const requestUrl = `spt/soccer/odds/update`
        const data = []
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              const oddChange = this.slug[slug].odds[odds][odds2][odd]
              data.push({
                id: oddChange.id,
                value: oddChange.value,
                active: oddChange.active ? 1 : 0,
                not_sync: oddChange.not_sync ? 1 : 0,
                spt_soccer_fixtures_id: this.fixtureId,
              })
            }
          }
        }
        axios.post(requestUrl, {odds: data})
          .then(response => {
            this.setBreakSync(slug, false)
            this.getDataOdds()

            this.$message.success({
              showClose: true,
              message: 'อัพเดตราคาเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })
      },
      createDataOdds(slug) {
        const requestUrl = `spt/soccer/odds/create`
        const data = []
        for (let odds  in _.get(this.slugCreate[slug], 'odds', [])) {
          for (let odd in _.get(this.slugCreate[slug], `odds.${odds}`)) {
            const oddChange = this.slugCreate[slug].odds[odds][odd]
            let dataSave = {
              header: oddChange.header,
              label: oddChange.label,
              value: oddChange.value,
              active: oddChange.active ? 1 : 0,
              not_sync: oddChange.not_sync ? 1 : 0,
              type: this.type,
              spt_soccer_fixtures_id: this.fixtureId,
              spt_soccer_fixtures_ref_id: this.fixtureRefId,
              slug: slug
            }
            if (oddChange.type === 'handicap') {
              dataSave.handicap = oddChange.handicap
            }
            if (oddChange.type === 'total') {
              dataSave.total = oddChange.total
            }
            data.push(dataSave)
          }
        }
//          swal({
//              title: "ยืนยันการเพิ่มราคา",
//              type: "warning",
//              showCancelButton: true,
//              confirmButtonColor: "#1ab394",
//              confirmButtonText: "ยืนยัน",
//              cancelButtonText: "ปิด",
//              closeOnConfirm: false
//            },
//            function() {
        axios.post(requestUrl, {odds: data, fixture_id: this.fixtureId})
          .then(response => {
            this.setCreateToggle(slug)
            this.getDataOdds()
            this.$message.success({
              showClose: true,
              message: 'เพิ่มราคา เรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })
//            }.bind(this))

      },
      getLastLogs(odds) {
        return getLogs(odds)
      },

      getBetTypeProps(slug, prop) {
        return _.get(_.find(this.betType, ['slug', slug]), prop)
      },
      getOdds(slug, prop, df = []) {
        return _.get(_.get(this.slug, slug), prop, df)
      },
      getProperty(data, key, df = '') {
        return _.get(data, key, df)
      },
      setSortHDA(odds) {
        return setSortHDA(odds)
      },
      setBreakSync(slug, force = true, toggle = true) {
        if (_.get(this.slug, `${slug}.editing`, false)) {
          if (!toggle) {
            return false
          }
          this.slug[slug].editing = false
          if (_.get(this.slugFlashData, slug) && force) {
            this.slug[slug] = _.cloneDeep(this.slugFlashData[slug])
          }
          return false
        } else {
          this.slugFlashData[slug] = _.cloneDeep(this.slug[slug])
          this.slug[slug].editing = true
          return true
        }
      },
      getBreakSync(slug) {
        return _.get(this.slug, `${slug}.editing`)
      },
      setSelectActiveAll(slug, e) {
        const status = e.target.checked
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              this.slug[slug]['odds'][odds][odds2][odd].active = status ? 1 : 0
            }
          }
        }
      },

      setSelectNotSyncAll(slug, e) {
        const status = e.target.checked
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              this.slug[slug].odds[odds][odds2][odd].not_sync = status ? 1 : 0
            }
          }
        }
      },
      isHandicap(record) {
        if (record.handicap !== null) {
          return true
        }
        return false
      },
      isTotal(record) {
        if (record.total !== null) {
          return true
        }
        return false
      },
      setCreateToggle(slug, force = true) {
        if (_.get(this.slugCreate, `${slug}.editing`, false)) {
          this.slugCreate[slug].editing = false
          if (_.get(this.slugCreateTemp, slug) && force) {
            this.slugCreate[slug] = _.cloneDeep(this.slugCreateTemp[slug])
          }
          return false
        } else {
          this.slugCreateTemp[slug] = _.cloneDeep(this.slugCreate[slug])
          this.slugCreate[slug].editing = true
          return true
        }
      },
      getCreateToggle(slug) {
        return _.get(this.slugCreate, `${slug}.editing`)

      },
      addMoreOdds(slug) {
        const data = _.cloneDeep(_.last(this.slugCreate[slug].odds))
        this.slugCreate[slug].odds.push(data)
      },
      removeOdds(slug, records, key) {
        if (_.get(records[key], 'remove_all', 0)) {
          records.splice(0)
        }
        const newData = []
        for (let odds  in _.get(this.slugCreate[slug], 'odds', [])) {
          if (_.get(this.slugCreate[slug], `odds.${odds}`).length) {
            newData.push(_.get(this.slugCreate[slug], `odds.${odds}`))
          }
        }
        this.slugCreate[slug].odds = _.cloneDeep(newData)
      },
      getChunk(type, record) {
        let className = ''
        if (!record.active) {
          className += 'c-unactive '
        }
        if (record.suspend === 1) {
          className += 'c-suspend '
        }
        return className + 'gl-cn-' + type.chunk
      },
      getSteamUrl(){
//        console.dir(_.filter(this.baseConfigVdo, ['site', this.currentSite]))
        return _.filter(this.baseConfigVdo, ['site', this.currentSite])
      },
      getInPlayScore(record) {
        return record.inplay_score ? record.inplay_score : '?-?'
      },
      getMatchStatus(fixture) {
        return getMatchStatus(fixture)
      },
      getTeamIcon(logoPath) {
        return getTeamIcon(logoPath)
      },
      paymentClass(record) {
        return paymentClass(record)
      },
      toFloat(value, fixed = 2) {
        return parseFloat(value).toFixed(fixed)
      },
      scoreDisplay(fixture) {
        return scoreDisplay(fixture)
      },
      scoreDisplayScore(fixture) {
        return scoreDisplayScore(fixture)
      },
      editStats(node, close = false) {
        const stats = _.cloneDeep(_.get(this.fixture, `stats.${node}`))
        this.statsActive = {}
        this.statsHome = null
        this.statsAway = null
        if (close) {
          return
        }
        this.statsActive[node] = true
        this.statsHome = _.get(stats, '[0]')
        this.statsAway = _.get(stats, '[1]')
      },
      saveDataStats() {
        const requestUrl = `spt/soccer/stats/update`
        const data = {
          fixture_id: this.fixture.id,
          type: _.keys(this.statsActive)[0],
          stats_home: this.statsHome,
          stats_away: this.statsAway
        }
        axios.post(requestUrl, data)
          .then(response => {
            this.getDataOdds()
            this.statsActive = {}

            this.$message.success({
              showClose: true,
              message: 'อัพเดตสถิติเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })
      },
      updateVdo() {
        const data = {
          fixture_id: this.fixture.id,
          vdo_url: this.fixture.vdo_url
        }
        this.updateData(data)
        this.editVdo = !this.editVdo
      },
      setActive(e) {
        const status = e.target.checked
        this.updateData({active: status})
      },
      updateData(params) {
        axios.put(`spt/soccer/${this.fixture.id}`, params)
          .then(response => {
            this.getDataOdds()
            this.$message.success({
              showClose: true,
              message: 'อัพเดตข้อมูลเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })
      }
      , renderStreaming() {
        this.sldpPlayer = SLDP.init({
          container: 'sldp_player_wrapper',
          stream_url: this.fixture.vdo_url,
          height: 360,
          width: 640,
          autoplay: true
        });
      },
      destroyVdo() {
        this.sldpPlayer.destroy()
      },

    },
    created() {

    },
    computed: {},
    beforeMount() {
    },
    watch: {
      'showVdo': {
        handler: function (value, old) {
          if (!value) {
            this.sldpPlayer.destroy()
          }
          else {
            this.renderStreaming()
          }
        },
      }
    }
  }
</script>
<style>
  .input-stats {
    width: 100px;
  }

  .onoffswitch-inner:before {
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/sports/soccerInPlay.vue